var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('button',{class:[
    'elst-button-submit',
    {
      'is-round': _vm.round,
      'is-big': _vm.size == 'big',
    },
  ],style:({
    width: `${_vm.width}px`,
  }),on:{"click":_vm.handle}},[_vm._v(" "+_vm._s(_vm.text || _vm.$t('button_common_hand_in'))+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }